<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body row-set-line">
  
                  <div class="col-12 col-sm-12 col-md-12 col-lg-4 mb-2">
                      <!-- <div class="btn-group enrollment-list-btn-info" role="group">
                        <button type="button" class="btn"
                          [ngClass]="{'btn-primary':activeTab=='mainmenu','btn-outline-primary':activeTab!='mainmenu'}"
                          (click)="activeMenuTab(activeTab=='mainmenu'?'':'mainmenu')">Main-Menu</button>
                        <button type="button" class="btn"
                          [ngClass]="{'btn-primary':activeTab=='submenu','btn-outline-primary':activeTab!='submenu'}"
                          (click)="activeMenuTab(activeTab=='submenu'?'':'submenu')">Sub-Menu</button>
                      </div> -->
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" #name />
                        <button class="btn search-btn glow position-absolute">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0 reset-btn">
                          Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="button" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          routerLink="/discussions/add" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
  
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-12 col-lg-12 pagination-body header-body mb-2">
                    <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                      [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                      [count]="page.totalPages" [offset]="page.pageNumber"
                      (page)="pageChangeData($event)"></ngx-datatable>
                  </div>
                  <div class="col-12">
                    <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Discussions Guideline</button>
                    </div>
                </div>
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
                (page)="pageChangeData($event)">
                <ngx-datatable-column name="Question" prop="question" [width]="100">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      <div class="cell-line-height cursor-pointer">
                        <p  class="font-medium-1 line-height-1 mb-0">
                          {{ row?.question }}
                        </p>
                      </div>
                    </div>
                  </ng-template>
                </ngx-datatable-column>
				<ngx-datatable-column name="Answer" prop="answer" [width]="100">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					  <div class="d-flex align-items-center">
						<div class="cell-line-height cursor-pointer">
						  <p *ngIf="row?.answer" (click)="openAnswerModal(myModalAnswer,row?._id)" class="font-medium-1 line-height-1 mb-0">
							{{ row?.answer }}
						  </p>
						  <i *ngIf="!row?.answer"  class="ft-plus-circle text-primary cursor-pointer  mx-1" (click)="openAnswerModal(myModalAnswer,row?._id)"></i>
						</div>
					  </div>
					</ng-template>
				  </ngx-datatable-column>
				<ngx-datatable-column name="Notes" prop="notes" [width]="60">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					  <div class="d-flex align-items-center">
						<div class="cell-line-height cursor-pointer">
						  <p class="font-medium-1 line-height-1 mb-0">
							{{ row?.notes }}
						  </p>
						</div>
					  </div>
					</ng-template>
				</ngx-datatable-column>
				
        <ngx-datatable-column name="Status" prop="status" [width]="30">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<p [matMenuTriggerFor]="status">
							<span *ngIf="row?.status == 'completed'"
								[ngClass]="{'bg-light-success badge badge-pill  cursor-pointer':row?.status == 'completed'}">
								{{row?.status}}
							</span>
							<span *ngIf="row?.status == 'pending'"
								[ngClass]="{'bg-light-danger badge badge-pill  cursor-pointer':row?.status == 'pending'}">
								{{row?.status}}
							</span>
              <span *ngIf="row?.status == 'decline'"
								[ngClass]="{'bg-light-warning badge badge-pill  cursor-pointer':row?.status == 'decline'}">
								{{row?.status}}
							</span>
						</p>
						<mat-menu #status="matMenu">
						  <div *ngFor="let status of discussion_status">
							<button mat-menu-item  *ngIf="status.name !== row?.status"
							  (click)="updateDiscussionStatus(row?._id,status.name)">
							  <span>
							  <span  *ngIf="status.name === 'completed'"  [ngClass]="{'bg-light-success badge badge-pill  cursor-pointer': status.name === 'completed'}"
								>{{status.name}}</span>
							  <span *ngIf="status.name ==='pending'" [ngClass]="{'bg-light-danger badge badge-pill  cursor-pointer': status.name === 'pending'}"
								>{{status.name}}</span>
                <span *ngIf="status.name ==='decline'" [ngClass]="{'bg-light-warning badge badge-pill  cursor-pointer': status.name === 'decline'}"
								>{{status.name}}</span>
							  </span>
							</button>
							</div>
						</mat-menu>
						</ng-template>
				</ngx-datatable-column>

                <ngx-datatable-column name="Actions" [width]="80"
                  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i mat-button [matMenuTriggerFor]="menu1"
                      class="ft-more-vertical text-primary cursor-pointer mr-2"></i>
  
                    <mat-menu #menu1="matMenu">
                      <button mat-menu-item (click)="editDiscussion(row)">Edit</button>                     
                      <button mat-menu-item (click)="Delete(row._id)">Delete</button>
                    </mat-menu>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <app-lms-content-editor #modalRef (closeModal)="closeModel()" [appType]="appType" [selectedApp]="selectedApp"></app-lms-content-editor>
<!---------- Discussion Answer  Popup ---------------->
<div>
	<ng-template #myModalAnswer let-modal>
		<div class="modal-header">
			<h4 class="modal-title" >Discussion Answer Update</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
			<form>
        <div class="form-group" >
          <label>Projects</label>
          <ng-select
          [items]="app_type_list"
          bindLabel="name"
          bindValue="name"
          [closeOnSelect]="false"
          placeholder="Select Type"
          [(ngModel)]="selected_app_type"
          [ngModelOptions]="{ standalone: true }"
          (change)="getAppType($event)"
          ></ng-select>
        </div>
				<div class="form-group">
					<label>Answer</label>
					<textarea name="model_answer" id="model_answer" placeholder="Enter answer"
					class="form-control" cols="30" rows="3"
					[(ngModel)]="model_answer"></textarea>
				</div>
			</form>
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
			<button type="button" class="btn btn-primary" (click)="discussionUpdate()">Submit</button>
		  </div>
	</ng-template>
</div>
